export default __webpack_public_path__ + "static/equipment-storage-845401f3b91566c01b37a3bdb1ec97ad.jpg";